import styles from './stylesSportsbookMainTabs.module.css';
import '../../../Dashboard/stylesDashboard.css';

function SportsbookMainTabs({
  activeTab,
  setActiveTab,
}) {
  return (
    <>
      <div className={styles.headControls}>
        <div className={styles.headerTextContainer}>
          <p className={styles.headerText}>Main Sportsbook</p>
        </div>
      </div>
      <div className="dashboard-tabs">
        <button
          className={activeTab === 'Popular SPGs' ? 'active' : null}
          onClick={() => setActiveTab('Popular SPGs')}
        >
          Popular SGPs
        </button>
      </div>
    </>
  );
}

export default SportsbookMainTabs;
